import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import cx from "classnames";
import _, { isEmpty } from "lodash";
import { Dropdown, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { FailureToast, SuccessToast } from "components/Toast";

import { fetchVariables } from "actions/variables";
import { fetchAudienceSegment, updateAndReorderAudienceSegment } from "actions/personalization";

import StoryboardContext from "components/Storyboard/context";
import InfiniteScroll from "components/InfiniteScroll";
import { LoadingMessage } from "pages/storyboards/storyboardSettings/leadReports/components";

import styles from "./variableList.module.scss";
import { useMemo } from "react";
import { ColorPickerVariable, ImageVaribale, TextVariableInput, VideoVaribale } from "pages/storyboards/storyboardSettings/personalization/components/variables";


export const VariablesListView = React.memo(({ data, handleUpdateValue, handleResetValue }) => {
  const dispatch = useDispatch();

  const { updatedSegment, segmentOrder } = data;

  const storyboardContext = React.useContext(StoryboardContext);
  const storyboardItem = useSelector((state) =>
    _.get(state, "storyboards.storyboard.item")
  );
  const storyboardId = useSelector((state) =>
    _.get(
      state,
      "storyboards.storyboard.item.id",
      _.get(storyboardContext, "id")
    )
  );

  const selectedCampaign = useSelector((state) => {
    const selectedId = _.get(state, "personalization.campaigns.selectedCampaign", null);
    const campaigns = _.get(state, "personalization.campaigns.items", []);
    
    return campaigns.find((campaign) => campaign.id === selectedId) || null;
  });

  const segmentItems = useSelector((data) =>
    _.get(data, `personalization.segments.data.${selectedCampaign?.id}.items`, [])
  ) || [];


  const selectedSegment = useSelector((state) => {
    const selectedId = _.get(state, "personalization.segments.selectedSegment", null);
    
    return segmentItems.find((segment) => segment.id === selectedId) || null;
  });

  const activeSegment = segmentItems?.find(seg => seg.id === selectedSegment?.id);
  
  const updating = useSelector((state) => _.get(state, "personalization.segments.updating"));

  const [filter, setFilter] = useState(null);
  const [variables, setVariables] = useState([]);

  const filterTypeOptions = [
    { label: "Text", value: "text" },
    { label: "Image", value: "image" },
    { label: "Color", value: "color" },
    { label: "Video", value: "video" },
  ];

  useEffect(() => {
    handleFetchVariables();
  }, [storyboardId]);

  useEffect(() => {
    if (_.isEmpty(updatedSegment.variables) && variables.length > 0){
      setVariables([]);
    }
  },[updatedSegment.variables])


  useEffect(()=>{
    if(selectedSegment && selectedSegment.id && !selectedSegment.varibales) {

      const request = {
        campaign: selectedCampaign?.id,
        segment: selectedSegment.id,
      }

      dispatch(fetchAudienceSegment(request));
    }
  },[selectedSegment?.id]);

  const handleFetchVariables = (page = 0) => {
    if (storyboardId) {
      var request = {
        storyboard: storyboardId,
        sort: "modified_date",
        order: "DESC",
      };
      dispatch(fetchVariables(request, page, 50));
    }
  };

  const variablesData = useSelector((state) =>
    _.get(state, "variables.items", [])
  );

  const pagination = useSelector((state) =>
    _.get(state, "variables.pagination", {})
  );
  const hasMoreItems =
    _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  const loadingVariable = useSelector((state) =>
    _.get(state, "variables.loading", [])
  );

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleFetchVariables(nextPage);
  };

  const handleChangeFilter = (filtervalue) => {
    if (!_.isEqual(filter, filtervalue)) {
      setFilter(filtervalue);
    }
  };

  const renderIcon = (fieldType) => {
    let iconClassName = "cleverstory-text-layer";

    switch (fieldType) {
      case "COLOR":
        iconClassName = "cleverstory-font-color";
        break;

      case "TEXT":
        iconClassName = "cleverstory-text-layer";
        break;

      case "IMAGE":
        iconClassName = "cleverstory-background";
        break;

      case "VIDEO":
        iconClassName = "cleverstory-video";
        break;
    }

    return iconClassName;
  };

  const triggerToastMessage =(type)=>{

    switch (type) {
      case "success":
        toast(
          <SuccessToast
            heading={`Success`}
            description="segment updated successfully"
          />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
        );
        break;
      case "error":
        toast(
          <FailureToast
            heading={`Failure`}
            description="segment updated Failed"
          />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
        );
        break;
    }
  }

  const optimizeCommands = (commands) => {
    if (!commands || typeof commands !== 'object') return {};
    
    const optimizedCommands = {};
    
    Object.keys(commands).forEach(key => {
      const commandGroup = commands[key];
      const isEmptyOperator = key === 'empty' || key === 'notEmpty';
      
      if (Array.isArray(commandGroup)) {
        const filteredGroup = commandGroup.filter(item => {
          if (!item) return false;
          
          if (isEmptyOperator) {
            return true;
          }
          
          return item.values && 
                 Array.isArray(item.values) && 
                 item.values.length > 0;
        });
        
        if (filteredGroup.length > 0) {
          optimizedCommands[key] = filteredGroup;
        }
      }
    });
    
    return optimizedCommands;
  };

  const handleSaveSegment = () => {
    if (
      updatedSegment.name === "" &&
      _.isEmpty(updatedSegment.variables) &&
      _.isEmpty(updatedSegment.commands) && _.isEmpty(segmentOrder)
    ) {
      return;
    }

    let updateRequest = null;
    let orderRequest = null;

    if(updatedSegment.name !== "" || !_.isEmpty(updatedSegment.variables) || !_.isEmpty(updatedSegment.commands)) {
      const activeSegmentVariables = _.get(activeSegment, 'mappings', []) || [];

      const getVariableValue = (id) => {
        const found = activeSegmentVariables.find((m) => m.variable === id);
        return found?.value ?? undefined;
      };

      const optimizedCommands = optimizeCommands(updatedSegment.commands);

  
      const baseMappings = variablesData.map((variable) => {
        const existingValue = getVariableValue(variable.id);
        const mapping = {
          variable: variable.id,
          type: variable.type,
          value: existingValue !== undefined ? existingValue : "",
        };
  
        if (!variable.userDefined) {
          mapping.uid = variable.name.toLowerCase().replace(/\s+/g, "");
        }
        return mapping;
      });
  
      // Override values from state.variables
      variables.forEach((updated) => {
        const match = baseMappings.find((m) => m.variable === updated.variable);
        if (match) {
          match.value =
            updated.value &&
            typeof updated.value === "object" &&
            (_.lowerCase(updated.value.type) === "image" || _.lowerCase(updated.value.type) === "video")
                ? updated.value.id
                : updated.value;
                match.override = !updated.value ? false :  true // track if this was overridden
        }
      });  
      
      // Filter: keep all userDefined=true + overridden userDefined=false
      const filteredMappings = baseMappings
        .filter((mapping) => {
          const original = variablesData.find((v) => v.id === mapping.variable);
          const changed = variables.find(o => o.variable === original.id);
          const overrideVariable = activeSegmentVariables.find(o => o.variable === original.id);
          if (!original.userDefined && (changed || overrideVariable)){
            return true;
          }
          if (original.userDefined) return true;
          return mapping.override; // only keep non-userDefined if overridden
        })
        .map((mapping) => ({
          ...mapping,
          value:
            mapping.value &&
            typeof mapping.value === "object" &&
            (_.lowerCase(mapping.value.type) === "image" || _.lowerCase(mapping.value.type) === "video")
              ? mapping.value.id
              : mapping.value,
          override: !mapping.value ? false : true,
        }));

      updateRequest = {
        id: selectedSegment?.id,
        campaign: selectedCampaign?.id || "",
        storyboard: storyboardId,
        ...(updatedSegment.name && { name: updatedSegment.name }),
        ...(!_.isEmpty(optimizedCommands) && { commands: optimizedCommands }),
        ...(!_.isEmpty(updatedSegment.variables) && { mappings: filteredMappings }),
      };
    }

    if(!_.isEmpty(segmentOrder)) {
      orderRequest = {
        entityOrderList: segmentOrder,
        campaign: selectedCampaign?.id || "",
        storyboard: storyboardId,
      };
    }

    dispatch(updateAndReorderAudienceSegment(updateRequest, orderRequest, (type)=>{
      triggerToastMessage(type);
      if(!_.isEmpty(segmentOrder)) {
        handleUpdateValue('segmentOrder', null);
      }
    }));
  };

  const updateChanges = (request) => {
    if (!request) {
      return;
    }

    const { variable, value, type } = request;

    setVariables((prevState) => {
      const prevVariables = prevState || [];
      const index = prevVariables.findIndex(
        (item) => item?.variable === variable.id
      );

      let updatedVariables;

      if (index !== -1) {
        // exists: only update value
        updatedVariables = [...prevVariables];
        updatedVariables[index] = {
          ...updatedVariables[index],
          overeride: true,
          value,
        };
      } else {
        // not exists: add new
        const newItem = {
          variable: variable.id,
          overeride: true,
          type: type,
          value,
        };

        if (variable.userDefined === false) {
          newItem.uid = variable.name.toLowerCase().replace(/\s+/g, "");
        }

        updatedVariables = [...prevVariables, newItem];
      }
      handleUpdateValue("variables", updatedVariables);
      return updatedVariables;
    });
  };

  const handleReset = () => {
    if(selectedSegment?.name !== updatedSegment.name || !_.isEqual(selectedSegment?.variables, updatedSegment.variables)) {
      handleResetValue()
      setVariables([]);
    }
  }

  return (
    <div className={styles.variablesListView}>
      <div className={styles.header}>
        <span className={styles.title}>List of Variables</span>

        <Dropdown className={cx(styles.filterOptionDropdown)}>
          <Dropdown.Toggle>{filter?.label || "All"}</Dropdown.Toggle>
          <Dropdown.Menu className="min-width-0">
            <Dropdown.Item
              active={!filter}
              onClick={() => {
                handleChangeFilter(null);
              }}
            >
              All
            </Dropdown.Item>
            {_.map(filterTypeOptions, (option) => {
              return (
                <Dropdown.Item
                  active={option.value === filter?.value}
                  onClick={() => {
                    handleChangeFilter(option);
                  }}
                >
                  {option.label}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {loadingVariable && variablesData && variablesData.length === 0 && (
        <div className={cx(styles.loader, styles.modalLoader)}>
          <LoadingMessage className={styles.loadingMessage} />
        </div>
      )}
      {variablesData && variablesData.length > 0 && (
        <InfiniteScroll
          className={cx(styles.variablesList)}
          loading={loadingVariable}
          hasMore={hasMoreItems}
          loadMore={loadMore}
        >
          {variablesData
            .filter((variable) => {
              if (variable.dynamic) return false;
              if (!filter) return true;
              return (
                variable.type?.toLowerCase() === filter.value.toLowerCase()
              );
            })
            .map((variable) => (
              <div
                key={variable.id || variable.name}
                className={styles.container}
              >
                <span className={styles.label}>
                  <i className={renderIcon(variable.type)} />
                  {variable.name}
                </span>
                <RenderVariableElement
                  variable={variable}
                  activeSegment={selectedSegment} 
                  storyboard={storyboardId}
                  storyboardItem={storyboardItem}
                  updatedValue={variables}
                  updateChanges={updateChanges}
                />
              </div>
            ))}
        </InfiniteScroll>
      )}
      <footer className={styles.userManagementFooter}>
        <div className={styles.footerAction}>
          <Button
            variant="secondary"
            onClick={handleReset}
            className={styles.cancelButton}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={(updatedSegment.name == "" &&  isEmpty(updatedSegment.variables) && isEmpty(updatedSegment.commands) && isEmpty(segmentOrder)) || updating || !selectedSegment}
            onClick={() => {
              handleSaveSegment();
            }}
            className={styles.saveButton}
          >
            { updating ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      </footer>
    </div>
  );
});


const RenderVariableElement = React.memo(
  ({ variable, activeSegment, updateChanges, updatedValue, storyboardItem }) => {
    const { type } = variable;
    const [value, setValue] = useState(null);
    const selectedCampaign = useSelector(state =>
      _.get(state, 'personalization.campaigns.selectedCampaign', null)
    );
    
    const selectedSegment = useSelector((state) =>
      _.get(state, "personalization.segments.selectedSegment", null));

    const segmentItems = useSelector(state =>
      _.get(state, `personalization.segments.data.${selectedCampaign}.items`, [])
    );
    
    const segmentMappings = useMemo(() => {
      const matchingSegment = segmentItems.find(item => item.id === selectedSegment);
    
      return matchingSegment?.mappings || [];
    }, [segmentItems, selectedSegment]);

    const handleChange = (value, fieldType) => {
      const requestUpdate = {
        variable: variable,
        type: fieldType,
        value: value,
      };
      setValue(value);
      updateChanges(requestUpdate);
    };

    useEffect(() => {
      if(selectedSegment) {
        handleResetValues();
        return;
      }

      setValue(null);
    }, [selectedSegment, activeSegment?.mappings]);

    useEffect(() => {
      if (_.isEmpty(updatedValue)) {
        handleResetValues();
      }
    }, [updatedValue, segmentMappings]);

    const handleResetValues = () => {
      if(!selectedSegment){
        return
      }

      setValue(null);
    
      const existingValue = getVariableValue(variable.id, segmentMappings);
    
      if (existingValue !== undefined && existingValue !== null) {
        setValue(existingValue);
        return;
      }

    };
    
    const getVariableValue = (variableId, changeValues) => {
      const found = changeValues?.find((item) => item?.variable === variableId);
      return found && found.value !== '' ? found.value : null;
    };
  
    

    switch (type) {
      case "TEXT":
        return (
          <TextVariableInput
            value={value}
            key={variable.id}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            onBlur={() => {
                const requestUpdate = {
                  variable: variable,
                  type: type,
                  value: value,
                };
                updateChanges(requestUpdate);
            }}
          />
        );

      case "COLOR":
        return (
          <ColorPickerVariable
            key={variable.id}
            value={
              value
                ? value
                : {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                    type: "solid",
                  }
            }
            onChange={(color) => {
              handleChange(color, type);
            }}
          />
        );

      case "IMAGE":
        return (
          <ImageVaribale
            key={variable.id}
            value={value}
            storyboard={storyboardItem}
            onChange={(image) => {
              handleChange(image, type);
            }}
          />
        );

      case "VIDEO":
        return (
          <VideoVaribale
            key={variable.id}
            value={value}
            storyboard={storyboardItem}
            onChange={(video) => {
              handleChange(video, type);
            }}
          />
        );

      default:
        return (
          <TextVariableInput
            value={value}
            key={variable.id}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            onBlur={() => {
                const requestUpdate = {
                  variable: variable,
                  type: type,
                  value: value,
                };
                updateChanges(requestUpdate);
            }}
          />
        );
    }
  }
);